import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TitleService } from 'src/app/services/title.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {

  private componentDestroyed = new Subject();
  private returnUrl!: string;

  constructor(
    private route: ActivatedRoute,
    private titleService: TitleService) {

    this.titleService.setTitle("Finansklagenemnda - Min sak - logg inn");

  }

  ngOnInit(): void {
    this.route.queryParams
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(params => {
        this.returnUrl = params['returnUrl'];
      });
  }

  ngOnDestroy(): void {
    this.componentDestroyed.next(null);
    this.componentDestroyed.unsubscribe();
  }

  login(idp: string): void {           
    var redirectUrl = '/api/oidc/authorize';
    redirectUrl += '?returnUrl=' + this.returnUrl;
    redirectUrl += '&idp=' + idp;   
    window.location.href = redirectUrl;
  }
}
